export default class RTPaaSError extends Error {

    constructor(message) {
        super(message);
    }

    static triggerRTPError(errorCode){
        window.dispatchEvent(new CustomEvent('rtpInfo', { detail : new RTPError(this.buildRTPError(errorCode))}));
    }

    static triggerAblyError(error){
        window.dispatchEvent(new CustomEvent('rtpError', { detail : new RTPAblyError(error)}));
    }

    static throwRTPError(error) {
        throw new RTPError(error);
    }

    static throwAblyError(error) {
        throw new RTPAblyError(error);
    }

    static buildRTPError(code) {
        let message = rtp_i18next.t(`errorMessages:${code}`);
        return {code, message};
    }
}

class RTPError extends RTPaaSError {
    constructor(error) {
        super(error.message);
        this.code = error.code;
        this.name = 'RTPError';
    }
}

class RTPAblyError extends RTPaaSError {
    constructor(error) {
        super(error.message);
        this.code = error.code;
        this.name = "RTPAblyError";
    }
}